import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import List from './List'
interface ListProps {
  states: [[string, string]],
  task_states: [[string, string]],
  roles: string[],
}
const ListApp = (props: ListProps) => {
  return <Router>
    <Route
      render={(internalProps) => <List {...internalProps} states={props.states} taskStates={props.task_states} roles={props.roles} />}
    />
  </Router>
}
  ;

export default ListApp

